import './TeachingLink';
import { Link, TeachingBubble, TooltipHost } from '../../fluent';
import { useEffect, useRef, useState } from 'react';
import React from 'react';
export const TeachingLink = (props) => {
    const dtRef = useRef(null);
    const [state, setstate] = useState({
        id: props.id || 0,
        isTeachingBubbleVisible: false,
        model: {},
        primaryButtonText: props.primaryButtonText || '',
        showPrimaryButton: props.showPrimaryButton || false,
        text: props.text || '',
        tooltip: props.tooltip || ''
    });
    useEffect(() => {
        setstate(Object.assign(Object.assign({}, state), { id: props.id || 0, primaryButtonText: props.primaryButtonText || '', showPrimaryButton: props.showPrimaryButton || false, text: props.text || '', tooltip: props.tooltip || '' }));
    }, [props]);
    const onOpenTeachingBubble = () => {
        props.onOpenTeachingBubble((value) => {
            setstate(Object.assign(Object.assign({}, state), { isTeachingBubbleVisible: true, model: value || {} }));
        });
    };
    const onDismiss = () => {
        setstate(Object.assign(Object.assign({}, state), { isTeachingBubbleVisible: false }));
    };
    const onAccept = () => {
        if (typeof props.onPrimaryButtonClick === 'function') {
            props.onPrimaryButtonClick();
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(TooltipHost, { content: state.tooltip },
            React.createElement(Link, { onClick: onOpenTeachingBubble },
                React.createElement("span", { ref: dtRef }, props.text))),
        state.isTeachingBubbleVisible
            ? React.createElement(TeachingBubble, { primaryButtonProps: state.showPrimaryButton ? {
                    children: state.primaryButtonText,
                    onClick: onAccept
                } : undefined, secondaryButtonProps: {
                    children: 'Cerrar',
                    onClick: onDismiss
                }, onDismiss: onDismiss, headline: props.text, targetElement: dtRef.current != null ? dtRef.current : undefined }, props.onRenderContent())
            : null);
};
